import Store from 'store/beedle.js';
import actions from 'store/actions.js';
import mutations from 'store/mutations.js';
import initialState from 'store/initialState.js';

export const storeInstance = new Store({
    actions,
    mutations,
    initialState
});

